import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { AngularFireAuth } from '@angular/fire/compat/auth';

import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";

import { take } from "rxjs/operators";
import { Storage } from '@ionic/storage';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private snapshotChangesSubscription: any;

  alertes = null;
  assainissements = null;
  avis = null;
  observations = null;
  users = null;
  climats = null;
  communes = null;
  agglos = null;


  constructor(
    public afs: AngularFirestore,
    private storage: Storage,
    public afAuth: AngularFireAuth
  ) { }


  async getObservations() {
    if (this.observations == null)
      await this.getObservationsFirebase();

    return this.observations;
  }
  async getObservationsByLocality(locality) {
    if (this.observations == null)
      await this.getObservationsFirebase();

    return this.observations.filter((alerte) => {
      return alerte.locality === locality;
    });
  }

  resetObservations() {
    this.observations = null;
  }

  getObservationsFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('observations');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.observations = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }




  async getAvis() {
    if (this.avis == null)
      await this.getAvisFirebase();

    return this.avis;
  }
  async getAvisByLocality(locality) {
    if (this.avis == null)
      await this.getAvisFirebase();

    return this.observations.filter((avi) => {
      return avi.locality === locality;
    });
  }

  resetAvis() {
    this.avis = null;
  }

  getAvisFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('avis');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.avis = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  async getAssainissements() {
    if (this.assainissements == null)
      await this.getAssainissementsFirebase();

    return this.assainissements;
  }

  async getAssainissementsByLocalities(localities) {
    if (this.assainissements == null)
      await this.getAssainissementsFirebase();
    // console.log('this.assainissements', this.assainissements);
    // console.log('localities', localities);
    return this.assainissements.filter((assainissement) => {
      return localities.indexOf(assainissement.locality) !== -1;
    });
  }
  async getAssainissementsByLocality(locality) {
    if (this.assainissements == null)
      await this.getAssainissementsFirebase();

    return this.assainissements.filter((alerte) => {
      return alerte.locality === locality;
    });
  }

  resetAssainissements() {
    this.assainissements = null;
  }

  getAssainissementsFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('assainissements');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.assainissements = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }


  updateAssainissement(assainissements) {
    return new Promise<any>((resolve, reject) => {
      console.log('from', JSON.parse(JSON.stringify(assainissements)));
      for (const key of Object.keys(assainissements)) {
        if (assainissements[key] === null) {

          delete assainissements[key];
        }
      }
      console.log('to', JSON.parse(JSON.stringify(assainissements)));
      this.afs.collection('assainissements')
        .doc(assainissements.id)
        .set(assainissements)
        .then(
          res => {
            console.log("updateAssainissement res", res);
            resolve(res)
          },
          err => {
            console.log("updateAssainissement err", err);
            reject(err)
          }
        )
    })
  }

  deleteAssainissement(assainissement) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('assainissements')
        .doc(assainissement.id)
        .delete()
        .then(
          res => {
            console.log("deleteAssainissement res", res);
            resolve(res)
          },
          err => {
            console.log("deleteAssainissement err", err);
            reject(err)
          }
        )
    })
  }

  async getAlertes() {
    if (this.alertes == null)
      await this.getAlertesFirebase();

    return this.alertes;
  }
  async getAlertesByLocalities(localities) {
    if (this.alertes == null)
      await this.getAlertesFirebase();

    return this.alertes.filter((alerte) => {
      return localities.indexOf(alerte.locality) !== -1;
    });
  }
  async getAlertesByLocality(locality) {
    if (this.alertes == null)
      await this.getAlertesFirebase();

    return this.alertes.filter((alerte) => {
      return alerte.locality === locality;
    });
  }

  resetAlertes() {
    this.alertes = null;
  }

  getAlertesFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('alertes');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.alertes = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }


  updateAlerte(alertes) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('alertes')
        .doc(alertes.id)
        .set(alertes)
        .then(
          res => {
            console.log("updateAlerte res", res);
            resolve(res)
          },
          err => {
            console.log("updateAlerte err", err);
            reject(err)
          }
        )
    })
  }

  deleteAlerte(alerte) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('alertes')
        .doc(alerte.id)
        .delete()
        .then(
          res => {
            console.log("deleteAlerte res", res);
            resolve(res)
          },
          err => {
            console.log("deleteAlerte err", err);
            reject(err)
          }
        )
    })
  }


  async getUsers() {
    if (this.users == null) {
      const users = await this.storage.get('users');
      const oneDay = new Date().getTime() + (1 * 24 * 60 * 60 * 1000);
      // console.log('debug', new Date().getTime(), users?.dateToRefresh);
      if (!users || new Date().getTime() > users.dateToRefresh) {
        await this.getUsersFirebase();
        this.storage.set('users', { dateCached: new Date().toISOString(), dateToRefresh: new Date(oneDay).getTime(), data: this.users });
      }
      else {
        this.users = users.data;
      }
    }

    return this.users;
  }

  resetUsers() {
    this.users = null;
  }

  getUsersFirebase() {
    console.log("getUsersFirebase")
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('users');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          console.log("snapshots", snapshots)
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.users = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }


  updateUser(user) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.user.subscribe(currentUser => {
        if (currentUser) {
          user.id = currentUser.uid;

          console.log("updateUser", user);
          this.afs.collection('users').doc(user.id)
            .set(user)
            .then(
              res => resolve(res),
              err => reject(err)
            )
        }
      });
    });
  }

  /* ----------------- */
  /* ---- AGGLOS ---- */
  /* ----------------- */

  async getAgglos() {
    if (this.agglos == null)
      await this.getAgglosFirebase();

    return this.agglos;
  }

  resetAgglos() {
    this.agglos = null;
  }




  async searchAgglos(search_key, search) {
    console.log("searchAgglos");
    if (this.agglos == null)
      await this.getAgglosFirebase();
    console.log("this.agglos ", this.agglos);
    console.log("search_key", search_key);
    console.log("search", search);
    let result = this.agglos.find((agglo) => {

      console.log('agglo[search_key]', agglo[search_key])
      console.log('search', search)
      console.log('agglo[search_key] === search', agglo[search_key] === search)
      return agglo[search_key] === search;
    });
    console.log("result", result);
    return result;
  }

  getAgglosFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('agglos');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.agglos = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  createAgglo(agglo) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('agglos').add(agglo)
        .then(
          res => {
            console.log("createAgglo res", res);
            resolve(res)
          },
          err => {
            console.log("createAgglo err", err);
            reject(err)
          }
        )
    })
  }

  updateAgglo(agglo) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('agglos')
        .doc(agglo.id)
        .set(agglo)
        .then(
          res => {
            console.log("updateAgglo res", res);
            resolve(res)
          },
          err => {
            console.log("updateAgglo err", err);
            reject(err)
          }
        )
    })
  }

  deleteAgglo(agglo) {
    console.log("deleteAgglo agglo", agglo);
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('agglos')
        .doc(agglo.id)
        .delete()
        .then(
          res => {
            console.log("deleteAgglo res", res);
            resolve(res)
          },
          err => {
            console.log("deleteCommune err", err);
            reject(err)
          }
        )
    })
  }

  /* ----------------- */
  /* ---- COMMUNES --- */
  /* ----------------- */

  async getCommunes() {
    if (this.communes == null)
      await this.getCommunesFirebase();

    return this.communes;
  }

  resetCommunes() {
    this.communes = null;
  }




  async searchCommunes(search_key, search) {
    console.log("searchCommunes");
    if (this.communes == null)
      await this.getCommunesFirebase();
    console.log("this.communes ", this.communes);
    console.log("search_key", search_key);
    console.log("search", search);
    let result = this.communes.find((commune) => {

      console.log('commune[search_key]', commune[search_key])
      console.log('search', search)
      console.log('commune[search_key] === search', commune[search_key] === search)
      return commune[search_key] === search;
    });
    console.log("result", result);
    return result;
  }

  getCommunesFirebase() {
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('communes');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.communes = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  createCommune(commune) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('communes').add(commune)
        .then(
          res => {
            console.log("createCommune res", res);
            resolve(res)
          },
          err => {
            console.log("createCommune err", err);
            reject(err)
          }
        )
    })
  }

  updateCommune(commune) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('communes')
        .doc(commune.id)
        .set(commune)
        .then(
          res => {
            console.log("updateCommune res", res);
            resolve(res)
          },
          err => {
            console.log("updateCommune err", err);
            reject(err)
          }
        )
    })
  }

  deleteCommune(commune) {
    console.log("deleteCommune commune", commune);
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('communes')
        .doc(commune.id)
        .delete()
        .then(
          res => {
            console.log("deleteCommune res", res);
            resolve(res)
          },
          err => {
            console.log("deleteCommune err", err);
            reject(err)
          }
        )
    })
  }



  async getClimats() {
    if (this.climats == null)
      await this.getClimatsFirebase();

    return this.climats;
  }

  resetClimats() {
    this.climats = null;
  }

  getClimatsFirebase() {
    console.log("getClimatsFirebase")
    return new Promise<any>((resolve, reject) => {
      let snapshotChangesRef = this.afs.collection('climats');//.orderBy('crea', 'asc'));// ref => ref.where('type', '==', type).orderBy('rank', 'asc').limit(400));
      snapshotChangesRef.snapshotChanges()
        .pipe(take(1))
        .subscribe(snapshots => {
          console.log("snapshots", snapshots)
          let result = snapshots.map(a => {
            const data: any = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
          });
          this.climats = result;
          resolve(result);
        }, err => {
          reject(err)
        })
    })
  }

  createAlerte(alerte) {
    return new Promise<any>((resolve, reject) => {
      // let currentUser = firebase.auth().currentUser;
      // if (!currentUser) {
      //   reject("not_logged");
      // };
      // let ligue = {
      //   author: currentUser.uid,
      //   name: name,
      //   private: true,
      //   status: 0,
      //   created_at: Date.now(),
      //   password: Math.random().toString(36).slice(5).toUpperCase(),
      // };
      // console.log("createLigue", ligue);
      this.afs.collection('alertes').add(alerte)
        .then(
          res => {
            console.log("createAlerte res", res);
            resolve(res)
          },
          err => {
            console.log("createAlerte err", err);
            reject(err)
          }
        )
    })
  }

  async getCurrentUser() {

    return await this.afAuth.currentUser;
  }

  uploadBase64(base64, randomId) {
    return new Promise<any>(async (resolve, reject) => {
      let currentUser: any = await this.getCurrentUser();

      const storage = getStorage();
      const storageRef = ref(storage, 'alertes/' + currentUser.uid + '/' + randomId);
      uploadString(storageRef, base64, 'data_url')
        .then(snapshot => {
          console.log("uploadBase64 putString success", snapshot);
          getDownloadURL(snapshot.ref)
            .then(res => resolve({
              snapshot: snapshot,
              url: res
            }))
        }, err => {
          console.error(err);
          reject(err);
        })
    })
  }

  createUser(uid, user) {
    return new Promise<any>((resolve, reject) => {
      console.log("createUser", user);
      this.afs.collection('users').doc(uid).set(user)
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  getUserLogged() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.user.subscribe(currentUser => {
        if (currentUser) {
          resolve(currentUser);
        }
      })
    })
  }

  encodeImageUri(imageUri, callback) {
    var c = document.createElement('canvas');
    var ctx = c.getContext("2d");
    var img = new Image();
    img.onload = function () {
      var aux: any = this;
      c.width = aux.width;
      c.height = aux.height;
      ctx.drawImage(img, 0, 0);
      var dataURL = c.toDataURL("image/jpeg");
      callback(dataURL);
    };
    img.src = imageUri;
  };

  uploadImage(imageURI, randomId) {
    return new Promise<any>((resolve, reject) => {
      const storage = getStorage();
      const imageRef = ref(storage, 'image/' + randomId);
      this.encodeImageUri(imageURI, function (image64) {
        uploadString(imageRef, image64, 'data_url')
          .then(snapshot => {
            getDownloadURL(snapshot.ref)
              .then(res => resolve(res))
          }, err => {
            reject(err);
          })
      })
    })
  }


  createAvis(alerte) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('avis').add(alerte)
        .then(
          res => {
            console.log("createAvis res", res);
            resolve(res)
          },
          err => {
            console.log("createAvis err", err);
            reject(err)
          }
        )
    })
  }
  updateAvis(alerte) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('avis').doc(alerte.id).set(alerte)
        .then(
          res => {
            console.log("createAvis res", res);
            resolve(res)
          },
          err => {
            console.log("createAvis err", err);
            reject(err)
          }
        )
    })
  }
  deleteAvis(alerte) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('avis').doc(alerte.id).delete()
        .then(
          res => {
            console.log("createAvis res", res);
            resolve(res)
          },
          err => {
            console.log("createAvis err", err);
            reject(err)
          }
        )
    })
  }
}
